import { getAllInvoiceInPublic } from '@modusign/openapi-client-payment';
import { GetAllInvoiceResDtoInPublic } from '@modusign/openapi-client-payment/model';
import { useQuery, UseQueryOptions } from 'react-query';
import { v4 } from 'uuid';

import { useWorkspaceId } from '@app/hooks/useWorkspaceId';

type Invoices = Pick<GetAllInvoiceResDtoInPublic, 'invoices'>['invoices'];

function useInvoices(options?: UseQueryOptions<Invoices>) {
  const workspaceId = useWorkspaceId();

  const result = useQuery<Invoices>(
    ['invoices'],
    async () => {
      const res = await getAllInvoiceInPublic(workspaceId);
      return res.invoices.map((invoice) => ({
        ...invoice,
        detail: {
          ...invoice.detail,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          deductionItems: invoice.detail.deductionItems.map((deductionItem: any) => {
            return { ...deductionItem, id: v4() };
          }),
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          purchaseItems: invoice.detail.purchaseItems.map((purchaseItem: any) => {
            return { ...purchaseItem, id: v4() };
          }),
        },
      }));
    },
    options
  );

  return result;
}

export default useInvoices;
